import React from 'react';
import './SpecialPricesProductGrid.css';
import { ApiProduct } from '../../types';
import { ProductBox } from '../ProductListing/ProductBox/ProductBox';
import { useTranslation } from '../../i18n/i18n';

type ProductCardProps = {
	handleAddProduct: () => void;
};

const EmptyProductBox: React.FC<ProductCardProps> = ({ handleAddProduct }) => {
	const t = useTranslation().specialPrices;
	return (
		<div className="product-card">
			<div className="plus-icon" onClick={handleAddProduct} />
			<button className="add-button" onClick={handleAddProduct}>
				{t.addProduct}
			</button>
		</div>
	);
};

type SpecialPricesProductGridProps = {
	selectedSpecialPriceProducts: ApiProduct[];
	totalSlots: number;
	handleAddProduct: (expiredProductId?: number) => void;
};

export const SpecialPricesProductGrid: React.FC<SpecialPricesProductGridProps> = ({
	selectedSpecialPriceProducts,
	totalSlots,
	handleAddProduct,
}) => {
	const handleChangeExpiredProduct = (productId: number) => {
		handleAddProduct(productId);
	};

	const selectedProductCards = selectedSpecialPriceProducts.map((selectedSpecialPriceProduct) => (
		<ProductBox
			product={selectedSpecialPriceProduct}
			key={selectedSpecialPriceProduct.id}
			displayLockedUntil
			disabled={selectedSpecialPriceProduct.deliveryClass === 6}
			onChangeExpiredProduct={handleChangeExpiredProduct}
		/>
	));

	const emptySlots = totalSlots - selectedSpecialPriceProducts.length;
	const emptyProductCards = Array.from({ length: emptySlots }, (_, index) => (
		<EmptyProductBox key={`empty-${index}`} handleAddProduct={handleAddProduct} />
	));

	return (
		<div id="product-grid-wrapper">
			<div className="product-grid">
				{selectedProductCards}
				{emptyProductCards}
			</div>
		</div>
	);
};
